<template>
  <div class="continer-wrap">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" :key="$route.name" v-if="$route.meta.keepAlive" />
      </keep-alive>
      <component :is="Component" v-if="!$route.meta.keepAlive" />
    </router-view>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { UserStore } from '@/store/modules/users'

  interface ArticleProps {
    type: 'zan' | 'attention' | 'comment' | string // 点赞 关注 评论
    id: string // id
    state: 0 | 1 | number // 点赞状态 关注状态
    total: number // 评论数量
  }

  const EVENTS = ['pageShow', 'pageShowEvents', 'notifyPostState']

  export default defineComponent({
    name: 'App',
    data() {
      return {
        isLogin: false,
        isFirst: true,
      }
    },
    created() {
      console.log('this.$bridge===', this.$bridge)
      const userStore = UserStore()
      // 初始化品牌ID
      userStore.setSourceApp()
      // 初始化APP版本
      userStore.setAppVersion()
      // 初始化设备ID
      userStore.setDeviceId()
      // 注册pageshow
      this.$bridge.regViewDidAppear(() => {
        console.log('触发pageShow')
        // pageShowEvents 兼容问答列表页
        this.$eventBus.emit('pageShowEvents', {})
        if (this.isFirst) {
          this.isFirst = false
          return
        }
        // 触发pageShow，重新拉取用户信息
        userStore.setUserInfo()

        this.$eventBus.emit('pageShow', {})
      })
      this.$bridge.regLoginSuccess(() => {
        console.log('触发登陆成功')
        // 触发pageShow，重新拉取用户信息
        userStore.setUserInfo()
      })
      // 注册点赞|评论|关注方法
      this.$bridge.register('nativeSyncPostState', (data: ArticleProps) => {
        this.$eventBus.emit('notifyPostState', data)
      })
      userStore.setPacket()
    },
    beforeUnmount() {
      EVENTS.map((key) => {
        this.$eventBus.off(key)
      })
    },
  })
</script>

<style lang="less">
  @import './less/index.less';

  .continer-wrap {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    background: #ffffff;
  }
</style>
